import React from "react";

const EmojiChip = props => {

    let emojiChip = <div className="emoji-chip">
        <button type="button" className="recommendation-btn" onClick={props.clicked} disabled={props.disabled}><i className="fas fa-icons"></i></button>
    </div>

    if (props.recommendations && props.recommendations !== []) {
        emojiChip = <div className="emoji-chip">
            {props.recommendations.map((emoji, index) => {
                return <button
                    type="button"
                    className="emoji-btn"
                    key={"emoji" + index}
                    onClick={(event) => props.emojiClicked(event, String.fromCodePoint("0x" + emoji))}>
                    <span role="img">{String.fromCodePoint("0x" + emoji)}</span>
                </button>
            })}
        </div>
    }

    return emojiChip;
}

export default EmojiChip;